module.exports = __webpack_public_path__ + "static/offer-brand-basic-4-7685adb2e458c343ea6931c906526b96.jpg";